export const environment = {
  klaviyoBisUrl: 'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe',
  klaviyoSubscriptionUrl: 'https://a.klaviyo.com/ajax/subscriptions/subscribe',
  klaviyoMetricsUrl: 'https://telemetrics.klaviyo.com/v1/metric',
};
